const HAS_TIMEZONE_SUFFIX = /(Z|[+-]\d{2}:?\d{2})$/i;
const SERVER_DATE_TIME = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/;

/**
 * 服务端 Mongo 时间按 UTC 保存，历史接口会返回不带时区的 ISO 字符串。
 * 浏览器直接解析会误当成本地时间，因此这里统一补上 UTC 标记。
 */
export const parseServerDateTime = (raw?: string | null) => {
  const value = String(raw || '').trim();
  if (!value) return 0;
  const normalized = SERVER_DATE_TIME.test(value) && !HAS_TIMEZONE_SUFFIX.test(value)
    ? `${value.replace(' ', 'T')}Z`
    : value;
  const timestamp = new Date(normalized).getTime();
  return Number.isFinite(timestamp) ? timestamp : 0;
};

const beijingDateKey = (timestamp: number) => {
  const parts = new Intl.DateTimeFormat('zh-CN', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date(timestamp));
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
};

export const formatBeijingRelativeTime = (timestamp: number) => {
  if (!timestamp) return '未知时间';
  const date = new Date(timestamp);
  const now = Date.now();
  const timeText = date.toLocaleTimeString('zh-CN', {
    timeZone: 'Asia/Shanghai',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  if (beijingDateKey(timestamp) === beijingDateKey(now)) return `今天 ${timeText}`;
  if (beijingDateKey(timestamp) === beijingDateKey(now - 24 * 60 * 60 * 1000)) return `昨天 ${timeText}`;
  const currentYear = beijingDateKey(now).slice(0, 4);
  const targetYear = beijingDateKey(timestamp).slice(0, 4);
  const dateText = date.toLocaleDateString('zh-CN', {
    timeZone: 'Asia/Shanghai',
    ...(currentYear === targetYear ? {} : { year: 'numeric' as const }),
    month: '2-digit',
    day: '2-digit',
  });
  return `${dateText} ${timeText}`;
};
